<mat-tab-group class="tab-container" (selectedTabChange)="onTabChange($event)" mat-align-tabs="center" mat-stretch-tabs [selectedIndex]="selectedTab" #tabGroup>
  <ng-container *ngFor="let offer of offers">
    <ng-container>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="d-flex flex-column align-items-center tab-icon" [gtmClick]="getViewLabel(offer + '_Tab_Title')">
            <mat-icon [svgIcon]="offerIcons[offer]" *ngIf="!active[offer]" class="tech-services-tab"></mat-icon>
            <mat-icon [svgIcon]="offerIcons[offer]" *ngIf="active[offer]" class="tech-services-tab-active"></mat-icon>
            <label>
              <adp-label [labelKey]="offer + '_Tab_Title'" class="tech-services-tab"></adp-label>
            </label>
          </div>
        </ng-template>
        <app-offer-content
          [offer]="offer"
          [contractId]="contractId"
          [userEmail]="userEmail"
          [userType]="userType"
          [usersOnContract]="usersOnContract"></app-offer-content>
      </mat-tab>
    </ng-container>
  </ng-container>
</mat-tab-group>
